import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import * as Sentry from "@sentry/react";
import { onetutor } from "../api/onetutor";
import statusSlice from "./statusSlice";

const sentryReduxEnhancer = Sentry.createReduxEnhancer();

export const store = configureStore({
  reducer: {
    [onetutor.reducerPath]: onetutor.reducer,
    status: statusSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(onetutor.middleware),
  enhancers: (getDefaultEnhancers) =>
    getDefaultEnhancers().concat(sentryReduxEnhancer),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
